<script>
	module.exports = {
		props: ['article', 'selectedArticle'],
		components: {
			'vocab-entry': require('components/vocab-entry.vue').default
		},
		computed: {
			activeArticle() {
				return this.selectedArticle || this.article;
			},
			senseIds() {
				const senses = this.activeArticle.vocab.support.senses;
				return Object.keys(senses);
			}
		}
	};
</script>
<template>
	<div class="printvocabulary">
		<vocab-entry
			v-for="senseId in senseIds"
			:key="senseId"
			:article="activeArticle"
			:sense-id="senseId"></vocab-entry>
	</div>
</template>
<style lang="scss">
	.printvocabulary {
		.vocab-entry {
			margin-bottom: 1rem;
		}

		.chinese-key-value {
			display: none;
		}
	}
</style>
